<template>
  <div class="text-center" v-if="user && canModify">
    <edit-user-model :is-active.sync="isEditting" :user="user" @edited="userEdited" />
    <edit-freeze-reason :is-active.sync="showFreezeDialog" :user="user" @edited="useFrozen" />
    <pin-reset-channel-selector
      :is-active.sync="showPinResetDialog"
      :user="user"
      @reset-sent="onPinResetSent"
    />
    <v-btn color="primary" class="mr-4" @click="resetPassword" v-on="on">
      <v-icon>mdi-account-edit-outline</v-icon>
      Reset Password
    </v-btn>
    <v-btn color="primary" class="mr-4" @click="openPinResetDialog" :loading="isResettingPin">
      <v-icon>mdi-lock-reset</v-icon>
      Reset PIN
    </v-btn>
    <v-menu
      v-model="menu"
      :nudge-width="200"
      offset-x
      :close-on-content-click="false"
      :close-on-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" v-on="on">
          <v-icon>mdi-account-edit-outline</v-icon>
          Account
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon size="60">mdi-shield-account-outline</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ user.full_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ userType }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="menu = false">
                <v-icon size="40">mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :input-value="user.is_individual"
                @change="changeIndividualUser"
                color="primary"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title>Is individual Customer</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>

        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :loading="isActivating"
                :input-value="!!user.is_active"
                @change="toggleActivity"
                :disabled="isActivating || user.client.is_frozen || user.is_rejected"
                color="primary"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title>Activate Account</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :input-value="user.is_verified"
                @change="verifyUser"
                color="primary"
                :disabled="user.is_verified || user.is_rejected"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title
              ><span v-if="user.is_verified">Verified</span
              ><span v-else>verify </span></v-list-item-title
            >
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :input-value="user.client.is_frozen"
                @change="toggleFreeze"
                color="primary"
                :disabled="user.client.frozen_at !== null || user.client.unfrozen_at !== null"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title
              ><span v-if="user.client.is_frozen">Freeze</span
              ><span v-else>Frozen </span></v-list-item-title
            >
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :loading="isRejecting"
                :input-value="user.is_rejected"
                @change="toggleReject"
                color="primary"
                :disabled="user.is_verified == true && user.is_active == true"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title
              ><span v-if="user.is_rejected">Is Rejected</span
              ><span v-else>Reject </span></v-list-item-title
            >
          </v-list-item>
        </v-list>
        <v-divider></v-divider>

        <v-card-actions>
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            text
            @click="generateVerificationUrl"
            :disabled="user.is_active || user.is_verified == false || user.is_verified != null"
          >
            <v-icon color="light-blue lighten-4">
              mdi-link
            </v-icon>
            Generate verification URL
          </v-btn>
          <v-btn text @click="isEditting = true" v-if="!user.is_archived">
            <v-icon color="light-blue lighten-4">
              mdi-account-edit-outline
            </v-icon>
            Edit
          </v-btn>
          <v-btn text @click="destroy(true)">
            <v-icon color="light-blue lighten-4">mdi-delete-circle-outline</v-icon>
            Delete
          </v-btn>
          <v-btn text @click="destroy(false)" v-if="!user.is_archived">
            <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
            Archive
          </v-btn>
          <v-btn text @click="restore" :loading="isRestoring" v-if="user.is_archived">
            <v-icon color="light-blue lighten-4">mdi-restore</v-icon>
            Restore
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import get from "lodash/get";
import { getUserType } from "./utils";

import EditUserModel from "./editUser";
import PinResetChannelSelector from "./pinResetChannelSelector";

export default {
  components: {
    EditUserModel,
    EditFreezeReason: require("./editFreezeReason").default,
    PinResetChannelSelector,
  },
  props: { user: { required: true, type: Object } },
  data: () => ({
    menu: false,
    isEditting: false,
    isActivating: false,
    isVerifying: false,
    isRestoring: false,
    isFreezing: false,
    isRejecting: false,
    isResettingPin: false,
    showFreezeDialog: false,
    showPinResetDialog: false,
  }),
  computed: {
    userType() {
      return getUserType(this.user);
    },
    canModify() {
      return get(this.$globalStore.user, "id") !== get(this.user, "id");
    },
  },
  methods: {
    resetPassword() {
      const id = this.user.id;
      Notify.confirm(`Confirm to Reset User Password`).then(() => {
        this.$http
          .get(`/api/v1/users/resetPassword/${id}`)
          .then((result) => {
            Notify.success(result.message);
            window.location.reload();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    openPinResetDialog() {
      this.showPinResetDialog = true;
    },

    onPinResetSent({ user }) {
      // Update user data if needed
      this.$emit("update:user", user);
    },

    // Keep the old resetPin method for backward compatibility but mark as deprecated
    resetPin() {
      this.openPinResetDialog();
    },
    toggleActivity() {
      const { id } = this.user;
      this.isActivating = true;
      this.$http
        .put(`api/v1/users/${id}/activity`)
        .then(({ user }) => {
          this.$emit("update:user", user);
          Notify.success("Operation was success full");
        })
        .finally(() => (this.isActivating = false));
    },
    async generateVerificationUrl() {
      const { id } = this.user;
      await this.$http
        .post(`api/v1/users/verify/${id}`)
        .then(({ user, message }) => {
          this.$emit("update:user", user);
          Notify.success(message);
        })
        .finally(() => {});
    },
    async changeIndividualUser() {
      const { id } = this.user;
      this.isActivating = true;
      await this.$http
        .put(`api/v1/users/${id}/change-individual-status`)
        .then(({ user }) => {
          this.$emit("update:user", user);
          Notify.success("Operation was success full");
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
          this.$emit("update:user");
        })
        .finally(() => (this.isActivating = false));
    },
    async verifyUser() {
      const { id } = this.user;
      this.isVerifying = true;
      await this.$http
        .post(`api/v1/users/${id}/verification`)
        .then(({ user }) => {
          this.$emit("update:user", user);
          Notify.success("Operation was success full");
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
          this.$emit("update:user");
        })
        .finally(() => (this.isVerifying = false));
    },
    async toggleFreeze() {
      this.isFreezing = true;
      const { id } = this.user;
      if (!this.user.client.is_frozen) {
        this.showFreezeDialog = true;
      } else {
        await this.$http
          .put(`api/v1/users/freeze/${id}`)
          .then(({ user }) => {
            this.$emit("update:user", user);
            Notify.success("Operation was successful");
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
            this.$emit("update:user");
          })
          .finally(() => (this.isFreezing = false));
      }
    },
    async toggleReject(val) {
      const { id } = this.user;
      const action = val === true ? "reject" : "accept";
      await this.$http
        .post(`api/v1/users/onboarding/${id}/${action}`, { type: "user" })
        .then(({ user }) => {
          this.$emit("update:user", user);
          Notify.success("Operation was successful");
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
          this.$emit("update:user");
        })
        .finally(() => (this.isRejecting = false));
    },
    useFrozen({ user }) {
      this.isFreezing = false;
      this.$emit("update:user", user);
      Notify.success("User was updated successfully");
    },
    userEdited({ user }) {
      this.isEditting = false;
      this.menu = false;
      this.$emit("update:user", user);
      Notify.success("User was updated successfully");
    },
    restore() {
      this.isRestoring = true;
      this.$http
        .post(`api/v1/users/restore/${this.user.id}`)
        .then(({ message }) => {
          this.isRestoring = false;
          Notify.success(message);
          this.$router.push({ name: "users" });
        })
        .catch((error) => {
          this.isRestoring = false;
          Notify.errorFromResponse(error, { close: true });
        });
    },
    destroy(permanent) {
      const params = {};
      if (permanent) {
        params.delete = true;
      }
      const title = permanent ? "This action is irreversible" : "The user will be archived";
      Notify.confirm(`${title}, All the user data will be lost`).then(() => {
        this.$http.delete(`/api/v1/users/${this.user.id}`, { params }).then(() => {
          Notify.success("User Was deleted successfully!");
          this.$router.push({ name: "users" });
        });
      });
    },
  },
};
</script>
